import React from 'react';
import { useParams } from 'react-router-dom';
import SignUp from './SignUp';

const SignUpReferral = () => {
  const { id: referral } = useParams();

  return (
    <>
      <SignUp referral={referral}>
      </SignUp>
    </>
  );
}

export default SignUpReferral;
